import { Action, createReducer, on } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import { ISearchEmployeeRequest, ISearchEmployeeResponse } from '../models/search-employees.model';
import { loadSearchEmployees, loadSearchEmployeesFailure, loadSearchEmployeesSuccess } from '../actions/search-employees.actions';
import { clearGlobalSearch } from '../actions/selected-employee.actions';

export const searchEmployeeFeatureKey = 'searchEmployee';

export interface SearchEmployeeState {
  searchEmployees: ISearchEmployeeRequest;
  searchEmployeesResponse: ISearchEmployeeResponse;
  searchEmployeesFailure: IGenericError<ErrorResponse>;
}

export const initialState: SearchEmployeeState = {
  searchEmployees: undefined,
  searchEmployeesFailure: undefined,
  searchEmployeesResponse: undefined
};

export const reducer = createReducer(
  initialState,

  on(loadSearchEmployees, (state, action) => ({
    ...state,
    searchEmployees: action.request
  })),
  on(loadSearchEmployeesSuccess, (state, action) => ({
    ...state,
    searchEmployeesResponse: action.response
  })),
  on(loadSearchEmployeesFailure, (state, action) => ({
    ...state,
    searchEmployeesFailure: action.error
  })),

  //clear Global Search store
  on(clearGlobalSearch, (state, action) => ({
    ...state,
    searchEmployeesResponse: undefined
  }))
);

export const getSearchEmployeesRequest = (state: SearchEmployeeState) => state.searchEmployees;
export const getSearchEmployeesResponse = (state: SearchEmployeeState) => state.searchEmployeesResponse;
export const getSearchEmployeesFailure = (state: SearchEmployeeState) => state.searchEmployeesFailure;
